import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { safeStorage } from '../utils/safeStorage';

export default function PublicRoute({ children }: { children: React.ReactNode }) {
  const { status, isPasswordRecovery } = useAuth();
  const location = useLocation();

  // Enquanto loading, mostra o conteúdo público (não redireciona)
  if (status === 'loading') {
    return <>{children}</>;
  }

  const params = new URLSearchParams(location.search);
  const isResetMode =
    isPasswordRecovery ||
    params.get('mode') === 'reset-password' ||
    (typeof window !== 'undefined' && window.location.hash.includes('type=recovery'));

  // Se o usuário estiver no fluxo de redefinição de senha, permite permanecer na tela
  if (isResetMode) {
    return <>{children}</>;
  }

  // Usuário logado tentando ver landing/auth → redireciona para o destino seguro ou /app por padrão
  if (status === 'authenticated') {
    const redirectTo = params.get('redirect') || safeStorage.getItem('rmax_pending_redirect') || '/app';
    const safeRedirect = redirectTo.startsWith('/') && !redirectTo.startsWith('//') ? redirectTo : '/app';
    return <Navigate to={safeRedirect} replace />;
  }

  return <>{children}</>;
}
